// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_field {
  width: 70%;
  height: 28px;
  padding-left: 2%;
  float: left;
}

.search_field::placeholder {
  font-size: 14px !important;
}

.mat-expansion-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  border-radius: inherit;
}

::ng-deep.list_accordion .mat-expansion-panel-header {
  height: 0px !important;
}

::ng-deep.mat-expansion-indicator {
  position: relative !important;
  right: 1% !important;
  top: -4px !important;
}

.filter_icon {
  position: relative;
  top: 7%;
}

.label_style {
  display: block;
  margin-block: 1%;
  font-size: 12px !important;
}

.search_control_w700 {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
}

.search_control_w700_input {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
}

input::placeholder {
  color: #797676 !important;
}

.w700_text {
  font-size: 12px !important !important;
}

::ng-deep.addComment.mat-menu-panel {
  transform-origin: right bottom;
  max-width: 600px !important;
  min-width: 335px !important;
  min-height: auto !important;
  position: relative;
  top: -23%;
}
::ng-deep.addComment.mat-menu-panel button.mat-menu-item {
  min-height: 112px !important;
}

.disable-backdrop-click .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  z-index: 999 !important;
}

::ng-deep.autocomplete-container .suggestions-container {
  position: absolute;
  width: 100%;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  visibility: visible;
}

::ng-deep.autocomplete-container .suggestions-container.is-visible {
  z-index: 999 !important;
}

.compendium_cast {
  font-size: 11px !important;
  height: 30px !important;
}

::ng-deep.compendium_casetype .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
}

::ng-deep.compendium_casetype .mat-form-field-wrapper {
  padding: 0px !important;
}

::ng-deep.compendium_casetype .mat-form-field-infix {
  padding: 4px !important;
  padding-bottom: 6px !important;
  padding-top: 0px !important;
}

.chipinput {
  height: 16px;
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: none !important;
  outline: 0 !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.checkbox {
  position: relative;
  top: 40%;
}

.mat-form-field {
  position: relative !important;
  text-align: left !important;
  display: block !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

::ng-deep.varules .mat-form-field-appearance-outline .mat-form-field-flex {
  padding: 0%;
}

.varule_textarea {
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

.addvarule {
  width: 50%;
  background-color: white;
  text-align: center;
  position: relative;
  top: 10%;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: right;
  height: 29px;
}

.addvarulebtn {
  font-size: 12px !important;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
}

.ellipsisfull {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100% !important; */
  max-width: 90%;
}

::ng-deep.varules .row {
  display: contents !important;
  flex-wrap: unset;
  margin-right: -15px;
  margin-left: -15px;
}

::ng-deep.list_accordion .row {
  display: flex !important;
  flex-wrap: unset;
  margin-right: -15px;
  margin-left: -15px;
  font-size: 12px;
}

::ng-deep.testmodecheckbox .mdc-checkbox {
  padding-right: 3px !important;
  bottom: 3px !important;
}

.text-ellipsis {
  white-space: nowrap !important;
  width: 40% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

::ng-deep.varulecheckox.mat-mdc-checkbox {
  width: 100% !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-form-field {
  width: 100% !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-form-field .mdc-label {
  margin-bottom: 0 !important;
  width: 100%;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.varulecheckox.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

.borderstyles {
  border: transparent !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

:ng-deep.mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/varules/varules.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACE,UAAA;EACA,YAAA;EAAc,gBAAA;EACd,WAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AACF;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,6BAAA;EACA,oBAAA;EACA,oBAAA;AAEF;;AACA;EACE,kBAAA;EAAmB,OAAA;AAGrB;;AAAA;EACE,cAAA;EACA,gBAAA;EACA,0BClCS;ADqCX;;AAAA;EACE,uBCnCW;EDoCX,0BCvCS;EDwCT,oDAAA;EACA,kBAAA;AAGF;;AADA;EACE,uBCzCW;ED0CX,0BC7CS;ED8CT,oDAAA;EACA,kBAAA;AAIF;;AAGA;EACE,yBAAA;AAAF;;AAEA;EACE,qCAAA;AACF;;AACA;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,kBAAA;EACA,SAAA;AACF;AAAE;EACE,4BAAA;AAEJ;;AAEA;EACE,oBAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;AAGF;;AAAA;EACE,mBAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AACA;EACE,0BAAA;EACA,uBAAA;AAEF;;AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAGF;;AADA;EACE,uBAAA;AAIF;;AAFA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;AAKF;;AAHA;EACE,YAAA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iCAAA;EACA,qCAAA;AAMF;;AAJA;EACE,kBAAA;EACA,QAAA;AAOF;;AALA;EACE,6BAAA;EACE,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,oDAAA;AAQJ;;AALA;EACE,WAAA;AAQF;;AANA;EACE,0BC9IS;ED+IT,oDAAA;AASF;;AAPA;EACG,UAAA;EACC,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;EACA,YAAA;EACA,YAAA;AAUJ;;AARA;EACI,0BC7JO;ED8JP,uBC5JQ;ED6JR,iBAAA;EACA,SAAA;EACA,OAAA;AAWJ;;AATA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAYF;;AATA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAYF;;AAVA;EACE,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAaF;;AAVE;EACE,6BAAA;EACA,sBAAA;AAaJ;;AAVA;EACE,8BAAA;EACA,qBAAA;EACA,kCAAA;EACA,2BAAA;AAaF;;AAVA;EACE,sBAAA;AAaF;AAZE;EACE,sBAAA;AAcJ;AAbI;EACE,2BAAA;EACA,WAAA;AAeN;AAZE;EACE,WAAA;EACA,YAAA;AAcJ;AAbI;EACE,gCCnNM;EDoNN,oCCpNM;ADmOZ;AAbI;EACE,YAAA;AAeN;AAZE;EACE,uBAAA;EACA,sBAAA;AAcJ;;AAXA;EACE,8BAAA;EACA,oDAAA;AAcF;;AAZA;EACE,wBAAA;AAeF","sourcesContent":["@import '../../variables.scss';\r\n.search_field{\r\n  width: 70%;\r\n  height: 28px; padding-left: 2%;\r\n  float: left;\r\n\r\n}\r\n.search_field::placeholder{\r\n  font-size: 14px !important;\r\n}\r\n\r\n.mat-expansion-panel-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  padding: 0;\r\n  border-radius: inherit;\r\n}\r\n::ng-deep.list_accordion .mat-expansion-panel-header {\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-expansion-indicator{\r\n  position: relative !important;\r\n  right: 1% !important;\r\n  top: -4px !important;\r\n}\r\n\r\n.filter_icon{\r\n  position: relative;top:7%;\r\n}\r\n\r\n.label_style{\r\n  display: block;\r\n  margin-block: 1%;\r\n  font-size: $fontsize;\r\n}\r\n\r\n.search_control_w700{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n}\r\n.search_control_w700_input{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n}\r\n// .search_control_w700_input::placeholder{\r\n//   color: black !important;\r\n//   font-weight: 700;\r\n// }\r\n\r\ninput::placeholder{\r\n  color: #797676 !important;\r\n}\r\n.w700_text{\r\n  font-size:$fontsize !important;\r\n}\r\n::ng-deep.addComment.mat-menu-panel {\r\n  transform-origin: right bottom;\r\n  max-width: 600px !important;\r\n  min-width: 335px !important;\r\n  min-height: auto !important;\r\n\r\n  position: relative;\r\n  top: -23%;\r\n  button.mat-menu-item {\r\n    min-height: 112px !important;\r\n  }\r\n}\r\n\r\n.disable-backdrop-click .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none;\r\n}\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  z-index: 999 !important;\r\n}\r\n::ng-deep.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n}\r\n\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  visibility: visible;\r\n}\r\n\r\n::ng-deep.autocomplete-container .suggestions-container.is-visible {\r\n  z-index: 999 !important;\r\n}\r\n\r\n\r\n.compendium_cast{\r\n  font-size:11px !important;\r\n  height: 30px!important;\r\n}\r\n::ng-deep.compendium_casetype .mat-standard-chip{\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height:unset;\r\n}\r\n::ng-deep.compendium_casetype .mat-form-field-wrapper{\r\n  padding: 0px !important;\r\n}\r\n::ng-deep.compendium_casetype  .mat-form-field-infix{\r\n  padding: 4px !important;\r\n  padding-bottom: 6px !important;\r\n  padding-top: 0px !important;\r\n}\r\n.chipinput{\r\n  height: 16px;\r\n  font-size: 11px !important;\r\n  box-sizing: border-box !important;\r\n  border: none !important;\r\n  box-shadow: none!important;\r\n  outline: 0 !important;\r\n  background-color: #fff !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n}\r\n.checkbox{\r\n  position: relative;\r\n  top:40%;\r\n}\r\n.mat-form-field{\r\n  position: relative!important;\r\n    text-align: left!important;;\r\n    display: block!important;;\r\n    border-radius: 5px!important;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n\r\n}\r\n::ng-deep.varules .mat-form-field-appearance-outline .mat-form-field-flex {\r\n  padding: 0%;\r\n}\r\n.varule_textarea{\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n.addvarule{\r\n   width: 50%;\r\n    background-color: white;\r\n    text-align: center;\r\n    position: relative;\r\n    top: 10%;\r\n    border-radius: 5px;\r\n    box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    float: right;\r\n    height: 29px;\r\n}\r\n.addvarulebtn{\r\n    font-size: $fontsize;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n}\r\n.ellipsisfull{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /* width: 100% !important; */\r\n  max-width: 90%;\r\n}\r\n\r\n::ng-deep.varules .row {\r\n  display: contents !important;\r\n  flex-wrap: unset;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n}\r\n::ng-deep.list_accordion .row {\r\n  display: flex !important;\r\n  flex-wrap: unset;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n  font-size: 12px;\r\n}\r\n::ng-deep.testmodecheckbox{\r\n  .mdc-checkbox{\r\n    padding-right: 3px !important;\r\n    bottom: 3px !important;\r\n  }\r\n}\r\n.text-ellipsis {\r\n  white-space: nowrap !important;\r\n  width: 40% !important;\r\n  text-overflow: ellipsis !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n::ng-deep.varulecheckox.mat-mdc-checkbox {\r\n  width: 100% !important;\r\n  .mdc-form-field{\r\n    width: 100% !important;\r\n    .mdc-label{\r\n      margin-bottom: 0 !important;\r\n      width: 100%;\r\n    }\r\n  }\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n.borderstyles{\r\n  border: transparent !important;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n:ng-deep.mat-mdc-form-field-subscript-wrapper{\r\n  display: none !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
